import { Plane, Truck, Rocket, Headphones } from "lucide-react";
import { PROCESS } from "@/lib/brand";

const ICONS = [Plane, Truck, Rocket, Headphones];

export const HowWeWork = () => {
  return (
    <section
      id="como"
      data-testid="how-we-work-section"
      className="relative py-24 lg:py-36 overflow-hidden grain"
    >
      {/* Cinematic cargo plane background */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1583266977403-9f5f5c8b8f65?auto=format&fit=crop&w=2400&q=80'), url('https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&w=2400&q=80')",
          backgroundSize: "cover, cover",
          backgroundPosition: "center, center",
        }}
        aria-hidden
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(10,25,47,0.92) 0%, rgba(10,25,47,0.86) 55%, rgba(10,25,47,0.95) 100%)",
        }}
        aria-hidden
      />
      <div
        className="absolute -top-32 left-1/3 w-[600px] h-[600px] rounded-full blur-3xl opacity-25 float-slower"
        style={{ background: "radial-gradient(closest-side, rgba(184,134,58,0.6), transparent)" }}
        aria-hidden
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-5 reveal">
            <span className="divider-gold" />
            <span className="tracking-eyebrow text-gold">Como Trabalhamos</span>
          </div>
          <h2
            className="font-display text-4xl lg:text-5xl font-bold text-white leading-[1.05] tracking-[-0.025em] reveal"
            data-testid="how-we-work-title"
          >
            Quatro pilares. Uma só missão:
            <br />
            <span className="text-white/75">manter você em produção.</span>
          </h2>
          <p className="mt-5 text-white/70 max-w-xl leading-relaxed reveal">
            Do sourcing global à entrega técnica no seu almoxarifado — engenharia de suprimentos ponta a ponta.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {PROCESS.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={p.step}
                className="reveal card-lift group relative rounded-3xl bg-white/[0.06] border border-white/10 backdrop-blur-md p-8 lg:p-10 overflow-hidden hover:bg-white/[0.10] hover:border-gold/40 transition-colors"
                data-testid={`process-card-${i}`}
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-14 h-14 rounded-2xl bg-white/10 border border-white/10 text-white flex items-center justify-center group-hover:bg-gold group-hover:border-gold transition-colors">
                    <Icon className="w-6 h-6" />
                  </div>
                  <div className="font-display text-6xl font-bold text-white/10 group-hover:text-gold/40 transition-colors">
                    {p.step}
                  </div>
                </div>
                <div className="font-display text-2xl font-semibold text-white mb-3">
                  {p.title}
                </div>
                <p className="text-white/70 leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
